import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b7c6c0cc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "slide-thumbnails" }
const _hoisted_2 = { class: "return-button" }
const _hoisted_3 = { class: "slide-thumbnails-content" }
const _hoisted_4 = ["onClick"]

import { PropType } from 'vue'
import { storeToRefs } from 'pinia'
import { useSlidesStore } from '@/store'
import useLoadSlides from '@/hooks/useLoadSlides'

import ThumbnailSlide from '@/views/components/ThumbnailSlide/index.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'SlideThumbnails',
  props: {
  turnSlideToIndex: {
    type: Function as PropType<(index: number) => void>,
    required: true,
  },
},
  emits: ["close"],
  setup(__props, { emit }: { emit: ({
  (event: 'close'): void
}), expose: any, slots: any, attrs: any }) {

const props = __props





const { slides, slideIndex } = storeToRefs(useSlidesStore())

const { slidesLoadLimit } = useLoadSlides()

const turnSlide = (index: number) => {
  props.turnSlideToIndex(index)
  emit('close')
}

return (_ctx: any,_cache: any) => {
  const _component_IconArrowCircleLeft = _resolveComponent("IconArrowCircleLeft")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_IconArrowCircleLeft, {
        class: "icon",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('close')))
      })
    ]),
    _createElementVNode("div", _hoisted_3, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(slides), (slide, index) => {
        return (_openBlock(), _createElementBlock("div", {
          class: _normalizeClass(["thumbnail", { 'active': index === _unref(slideIndex) }]),
          key: slide.id,
          onClick: ($event: any) => (turnSlide(index))
        }, [
          _createVNode(ThumbnailSlide, {
            slide: slide,
            size: 150,
            visible: index < _unref(slidesLoadLimit)
          }, null, 8, ["slide", "visible"])
        ], 10, _hoisted_4))
      }), 128))
    ])
  ]))
}
}

})